import { useFrame } from "@react-three/fiber";
import React, { useRef } from "react";
import * as THREE from "three";

interface AnimatedTextureProps {
  meshRef: React.RefObject<THREE.Mesh>;
  directory: string;
  fileCount: number;
  fileNamePattern: string;
  isActive: () => boolean;
  isAlphaMapEnabled: false;
  texturesCache: THREE.Texture[];
}

export const AnimatedTexture: React.FC<AnimatedTextureProps> = ({
  meshRef,
  directory,
  fileCount,
  fileNamePattern,
  isActive,
  isAlphaMapEnabled = false,
  texturesCache,
}) => {
  const frameIndex = useRef(0);
  const textureFrames: any = useRef({}); // useLoader(TextureLoader, textureFiles);
  const alphaMaps: any = useRef({});
  useFrame(async () => {
    if (meshRef.current && meshRef.current.material && isActive()) {
      frameIndex.current = (frameIndex.current + 1) % fileCount;
      const currenFrameName = fileNamePattern.replace(
        "{i}",
        frameIndex.current.toString(),
      );
      const newFrame = textureFrames.current[currenFrameName]
        ? textureFrames.current[currenFrameName]
        : texturesCache.find((t) => t.userData.name === currenFrameName);

      const material = meshRef.current.material as THREE.MeshStandardMaterial;
      material.transparent = true;

      if (isAlphaMapEnabled && !alphaMaps?.current[material.name]) {
        alphaMaps.current[material.name] = texturesCache.find(
          (t) => t.userData.name === material.name,
        );

        material.alphaMap = alphaMaps.current[material.name];
      }

      material.map = newFrame;

      material.needsUpdate = true;
    }
  });

  return null;
};
